import React, { useState } from "react";
import "./Landing.css";

const Landing = () => {
  const [authError, setAuthError] = useState("");



  const startLogin = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const tenantId = process.env.REACT_APP_TENANT_ID;
    const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI || "");
    const scope = encodeURIComponent(process.env.REACT_APP_BACKEND_SCOPE || "");

    if (!clientId || !tenantId || !redirectUri || !scope) {
      setAuthError("Missing environment variables");
      return;
    }

    const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?` +
      `client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}` +
      `&response_mode=query&scope=${scope}&state=landing_page`;

    window.location.href = authUrl;
  };

  const clearError = () => setAuthError("");

  return (
    <div className="landing-container">
      {/* Navbar */}
      <nav className="landing-navbar">
        <div className="landing-logo">
          <span>Finance</span>
        </div>
        <div className="landing-navButtons">
         
        </div>
      </nav>

      {/* Hero */}
      <section className="landing-hero">
        
          <>
            <h1>
              Finance Management <span>Accounting</span>
            </h1>

            <button className="landing-cta" onClick={startLogin}>
              Login with Microsoft
            </button>

            {authError && (
              <div className="landing-error">
                Authentication failed: {authError}
                <button
                  onClick={clearError}
                  style={{
                    marginLeft: "0.5rem",
                    background: "transparent",
                    border: "none",
                    color: "#4e9af1",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}
                >
                  ×
                </button>
              </div>
            )}
          </>
        
      </section>
    </div>
  );
};

export default Landing;